(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-wall"] && !Shopify.designMode) return;
  try {
    
  class ReviewsWall extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-reviews-toggle]');
      this.grid = this.querySelector('[data-reviews-track]');
      this.modal = this.querySelector('[data-reviews-modal]');
      this.modalBody = this.querySelector('[data-reviews-modal-body]');
      this.closeBtn = this.querySelector('[data-reviews-modal-close]');
      this.labelMore = this.querySelector('[data-label-more]');
      this.labelLess = this.querySelector('[data-label-less]');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.placeholder = null;

      if (this.toggle) this.toggle.addEventListener('click', () => this.onToggle());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeModal());
      if (this.modal) {
        this.modal.addEventListener('close', () => this.afterModalClose());
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.closeModal();
        });
      }
    }

    onToggle() {
      if (this.desktop.matches) {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (this.labelMore) this.labelMore.hidden = expanded;
        if (this.labelLess) this.labelLess.hidden = !expanded;
      } else {
        this.openModal();
      }
    }

    openModal() {
      if (!this.modal || !this.grid || !this.modalBody) return;
      this.placeholder = document.createComment('reviews-grid');
      this.grid.before(this.placeholder);
      this.modalBody.appendChild(this.grid);
      if (typeof this.modal.showModal === 'function') {
        this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
    }

    closeModal() {
      if (this.modal && typeof this.modal.close === 'function') {
        this.modal.close();
      } else {
        this.afterModalClose();
      }
    }

    afterModalClose() {
      if (this.placeholder && this.grid) {
        this.placeholder.replaceWith(this.grid);
        this.placeholder = null;
      }
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('reviews-wall')) {
    customElements.define('reviews-wall', ReviewsWall);
  }

  } catch(e) { console.error(e); }
})();
})();
